import type { TrainerFormRequest } from './type';

export const defaultTrainerForm: TrainerFormRequest = {
  email: '',
  name: '',
  gender: '',
  phone: '',
  level: '',
  password: '',
  institutionId: '',
  firstName: '',
  lastName: '',
};

export const defaultAddTrainerForm: TrainerFormRequest = {
  email: '',
  name: '',
  gender: '',
  phone: '',
  level: '',
  institutionId: '',
  firstName: '',
  lastName: '',
};
